import { useCallback } from 'react';
import { useButtonAction } from '../helpers/useButtonAction';
import { ButtonProps } from '../types';
import { useStore } from '@/store/useStore';
import {
  TRACK_USER_ACTION_EVENT,
  useTrackUserAction,
} from '@/utilities/logger/amplitude/tracking';
import { POPUP_TYPES } from '../constants';

const PopupButton: React.FC<{ idx: number; props: ButtonProps }> = ({
  idx,
  props,
}) => {
  const { clickAction } = useButtonAction(props.buttonType);
  const { trackUserAction } = useTrackUserAction();

  const handleClick = useCallback(() => {
    const currentPopupType = useStore.getState().state?.[0]?.type;
    if (currentPopupType === POPUP_TYPES.PROVIDER) {
      trackUserAction({
        event: TRACK_USER_ACTION_EVENT.IN_GAME_ERROR_CTA_CLICKED,
        zone: 'DASHBOARD',
        linkText: props.buttonType,
      });
    }
    // Use custom onClick if provided, otherwise use the default action
    if (props.onClick) {
      props.onClick();
    } else {
      clickAction();
    }
  }, [clickAction, props, trackUserAction]);
  const testId =
    props.dataTestId ?? `${props.buttonType.replace(/_/g, '-')}-button`;

  return (
    <button
      key={idx}
      className={`popup__button popup__button--${
        props.buttonClass ? props.buttonClass : idx === 0 ? 'main' : 'secondary'
      }`}
      data-testid={testId}
      onClick={handleClick}
      type="button"
    >
      {props.buttonMessage}
    </button>
  );
};

export default PopupButton;
